import { DataProcessingOption } from "models/DataProcesses";
import { useEffect, useState } from "react";
import MontageService from "services/MontageService";

const useDataProcessingRedactionOptions = () => {
    const [data, setData] = useState<DataProcessingOption[] | null>();
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        let destroyed = false;
        const runFn = async () => {
            try {
                setIsLoading(true);
                const res = await MontageService.listRedactionServices();
                if (!destroyed) {
                    setData(res);
                    setIsLoading(false);
                }
            } catch (err) {
                console.error(err);
                setIsLoading(false);
            }
        };
        runFn();
        return () => {
            destroyed = true;
            setData(null);
        };
    }, []);

    return {
        data,
        isLoading,
    };
};

export default useDataProcessingRedactionOptions;
